type Title = { [key: string]: any };
type HeaderLinks = {
   external?: boolean;
   title: Title;
   href: string;
   section?: string;
}[];
export const header_links: HeaderLinks = [
   {
      external: false,
      href: '/madinah/destinations',
      title: {
         en: 'Destinations',
         ar: 'الوجهات',
         fr: 'Destinations',
         tr: 'Hedefler',
         urd: 'مقامات',
         id: 'Destinasi',
      },
      // section: 'destinations',
   },
   {
      external: false,
      href: '/search',
      title: {
         en: 'Experiences',
         ar: 'تجارب',
         fr: 'Expériences',
         tr: 'Deneyimler',
         urd: 'تجربے',
         id: 'Pengalaman',
      },
   },
   {
      external: false,
      href: '/madinah/madinah_culture',
      title: {
         en: 'Madinah Culture',
         ar: 'ثقافة المدينة',
         fr: 'Culture de Médine',
         tr: 'Madinah Kültürü',
         urd: 'ثقافة المدينة',
         id: 'Budaya Madinah',
      },
      // section: 'madinah_culture',
   },
   {
      external: false,
      href: '/madinah/plan_your_visit',
      title: {
         en: 'Plan Your Visit',
         ar: 'خطط لزيارتك',
         fr: 'Plannez Votre Visite',
         tr: 'Ziyaretinizi Planlayın',
         urd: 'اپنی دورہ کی منصوبہ بندی کریں',
         id: 'Rencanakan Kunjungan Anda',
      },
      // section: 'plan_your_visit',
   },
];
